<template>
    <div class="grid py-3 px-2" style="grid-template-rows: auto auto; grid-template-columns: 1fr 1fr">
        <!-- Первая строка: левая и правая часть -->
        <div class="text-left">
            <span v-if="statusMessage" class="text-gray-500">{{ statusMessage }}</span>
        </div>
        <div class="flex justify-end gap-2">
            <span v-if="showSelected">Выбрано элементов: {{ selectedCount }}</span>
            <span>Всего элементов: {{ totalCount }}</span>
        </div>
        <!-- Вторая строка: текущее значение (на всю ширину и справа) -->
        <div v-if="currentValue" class="col-span-2 text-right">
            <span><br /><b>Текущее значение:</b> {{ currentValue }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ai-grid-virtual-footer',
};
</script>

<script setup>
defineProps({
    showSelected: {
        type: Boolean,
        default: () => true,
    },
    totalCount: {
        type: Number,
        default: () => 0,
    },
    selectedCount: {
        type: Number,
        default: () => 0,
    },
    currentValue: {
        type: String,
    },
    statusMessage: {
        type: String,
        default: () => '',
    },
});
</script>

<style scoped>
:deep(.dx-menu-item-content) {
    display: flex;
    align-items: center;
}
</style>
